/**
 * Turboユーティリティ
 *
 * Turbo Frame関連のヘルパーメソッドを提供するMixin。
 *
 * === Turbo Frame ===
 * reloadPayoutRequestHistoryFrame()   - 出金履歴Turbo Frameをリロード
 * reloadHarvestHistoryFrame()         - 収穫残高履歴Turbo Frameをリロード
 */

export const TurboHelpersMixin = {
  // ============================================
  // Turbo Frame
  // ============================================

  /**
   * 出金履歴Turbo Frameをリロード
   * submit/cancel後に最新データを反映
   * 現在選択中の年パラメータを維持
   */
  reloadPayoutRequestHistoryFrame() {
    if (!this.selectedPayoutRequestHistoryYearValue) return;
    this.updatePayoutRequestHistoryFrameSrc(this.selectedPayoutRequestHistoryYearValue);
  },

  /**
   * 収穫残高履歴Turbo Frameをリロード
   * submit/cancel後に残高が変わるため最新データを反映
   * 現在選択中の年パラメータを維持
   */
  reloadHarvestHistoryFrame() {
    if (!this.selectedHarvestHistoryYearValue) return;
    this.updateHarvestHistoryFrameSrc(this.selectedHarvestHistoryYearValue);
  },
};
